import { useRef, useCallback } from 'react';

/**
 * V273: 모달 오버레이 닫기 시 드래그 오작동 방지 훅.
 *
 * mousedown과 mouseup(click)이 **모두** 오버레이 자체에서 발생한 경우에만 onClose를 호출.
 * 모달 내부 input/textarea에서 텍스트 드래그하다 바깥으로 마우스를 빼도 닫히지 않음.
 *
 * 사용법:
 *   const overlayProps = useModalOverlayClose(onClose);
 *   <div style={overlayStyle} {...overlayProps}>
 *     <div style={modalStyle}>...</div>
 *   </div>
 */
export function useModalOverlayClose(onClose: (() => void) | undefined) {
  const mouseDownTargetRef = useRef<EventTarget | null>(null);

  const onMouseDown = useCallback((e: React.MouseEvent) => {
    mouseDownTargetRef.current = e.target;
  }, []);

  const onClick = useCallback((e: React.MouseEvent) => {
    // mousedown 시작과 click 종료가 모두 오버레이(currentTarget) 자체일 때만 닫기
    if (
      e.target === e.currentTarget &&
      mouseDownTargetRef.current === e.currentTarget
    ) {
      onClose?.();
    }
    mouseDownTargetRef.current = null;
  }, [onClose]);

  return { onMouseDown, onClick };
}
